export default "__VITE_ASSET__DQ1p3RoQ__"